import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Reservation from "../components/Reservation";
import Menu from "../components/Menu";
import "./Home.css";

export default function Home() {
  return (
    <div id="home">
      <Navbar />

      <section className="hero-section">
        <div className="hero-overlay">
          <h1>Welcome to Turca Breakfast House</h1>
          <p>Where flavor meets comfort.</p>
        </div>
      </section>

      <section id="menu" className="content-section">
         <Menu />
      </section>

      <section id="about" className="content-section">
        <h2>About Us</h2>
        <p>Turca Breakfast House is a cozy escape where great taste meets great company.</p>
      </section>

      <section id="contact" className="content-section contact-section">
        <div className="contact-container">
          {/* Left: Google Maps */}
          <div className="contact-map">
            <iframe
              title="Turca Breakfast House Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2896.988312543406!2d-114.09345008450736!3d51.0530649795698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5371776d36c75b91%3A0x1c8e7e57488c1078!2s2604%204%20St%20NW%2C%20Calgary%2C%20AB%20T2M%203A1!5e0!3m2!1sen!2sca!4v1708892345678!5m2!1sen!2sca"
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: "15px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* Right: Contact Info */}
          <div className="contact-info">
            <h2>Contact Information</h2>
            <p><strong>Address:</strong> 2604 4 St NW, Calgary, AB T2M 3A1</p>
            <p><strong>Phone:</strong> (403) 613-9707</p>
            <p><strong>Email:</strong> info@turca.ca</p>
            <p><strong>Business Hours:</strong></p>
            <p>Monday: Closed</p>
            <p>Tuesday – Friday: 8 am – 4 pm</p>
            <p>Saturday & Sunday: 8 am – 5 pm</p>
          </div>
        </div>
      </section>
      <Footer/>

    </div>
  );
}
